// components/ProductsDrawer.js
import { Drawer } from "antd";
import { get, groupBy } from "lodash";
import { MdOpenInNew } from "react-icons/md";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import { COLORS } from "shared/style/colors";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

const ProductsDrawer = ({
  open,
  onClose,
  selectedInsurancePlans,
  selectedModules,
  onCheck,
  insurancePlan,
  cost,
  currency,
  disabled,
  translation,
  onOpenDetails,
  selectedInsuranceOptions,
}) => {
  const symbol = CURRENCY_SYMBOL[currency];
  const totalCost = get(selectedModules, insurancePlan.id, [])
    ?.reduce((acc, curr) => {
      return acc + curr.cost;
    }, cost)
    ?.toFixed(2);
  const [integer, decimal = ""] = costToFrench(totalCost?.toString())?.split(
    ",",
  ) || ["-"];

  const groupedByWeight = groupBy(
    selectedInsurancePlans,
    (item) => item.weight,
  );

  const sortedGroups = Object.entries(groupedByWeight)
    .sort(([weightA], [weightB]) => Number(weightB) - Number(weightA))
    .map(([, items]) => items);

  return (
    <Drawer
      className="drawer__area"
      title={get(translation, "UPSELLS.COMPLEMENTS_MANAGEMENT", "")}
      width={500}
      onClose={onClose}
      open={open}
      placement="right"
    >
      <div className="upsells__details">
        <div className="upsells__details--header">
          <div className="upsells__details--left">
            <img
              className="upsells__details--image"
              src={insurancePlan.icon}
              alt={insurancePlan.name}
            />
            <div className="upsells__details--name">{insurancePlan.name}</div>
          </div>
          <div className="upsells__details--right">
            <div className="insurance-plan__cost">
              <span className="insurance-plan__cost--integer">
                {`${integer} ${symbol} `}
                <span className="insurance-plan__cost--decimal">{`${decimal}`}</span>
              </span>
              <span className="insurance-plan__cost--period">{` /mois`}</span>
            </div>
            <span className="insurance-card__item--total">
              {`${(+totalCost * 12).toFixed(0)} ${symbol} / an `}
              <span>{get(translation, "UPSELLS.ALL_INCLUDED", "")}</span>
            </span>
          </div>
        </div>
        {sortedGroups.map((data, i) => (
          <div key={`grp-${i}`} className="upsells__details--body">
            {data?.map((module) => {
              const [integer, decimal = ""] = costToFrench(
                get(module, "cost", 0)?.toString(),
              )?.split(",") || ["-"];
              const symbol = CURRENCY_SYMBOL[currency];
              return (
                <>
                  <div
                    key={get(module, "insurancePlan.id")}
                    className="upsells__checkbox"
                  >
                    <div className="upsells__checkbox--left">
                      <Input
                        type="checkbox"
                        label={get(module, "insurancePlan.name")}
                        onChange={({ target: { checked } }) =>
                          onCheck({ module, checked })
                        }
                        checked={
                          get(selectedModules, insurancePlan.id, []).find(
                            ({ insurancePlan }) =>
                              insurancePlan?.id ===
                              get(module, "insurancePlan.id", ""),
                          ) || false
                        }
                        disabled={disabled}
                      />
                      <div
                        className="upsells__checkbox--button"
                        onClick={() =>
                          onOpenDetails(get(module, "insurancePlan.id"))
                        }
                      >
                        <MdOpenInNew size={16} color={COLORS.C_PRIMARY} />
                      </div>
                    </div>
                    <div className="upsells__details--right">
                      <div className="insurance-plan__cost">
                        <span className="upsells__details--integer">
                          {`${integer} ${symbol} `}
                          <sup>{`${decimal}`}</sup>
                        </span>
                        <span className="upsells__details--period">{` /mois`}</span>
                      </div>
                    </div>
                  </div>
                  {get(
                    selectedInsuranceOptions,
                    get(module, "insurancePlan.id", []),
                  )?.map((option) => {
                    const [integer, decimal = ""] = costToFrench(
                      get(option, "cost", 0)?.toString(),
                    )?.split(",") || ["-"];
                    const symbol = CURRENCY_SYMBOL[currency];
                    return (
                      <div
                        key={get(option, "insurancePlan.id")}
                        className="upsells__checkbox p-left-24"
                      >
                        <div className="upsells__checkbox--left">
                          <Input
                            type="checkbox"
                            label={get(option, "insurancePlan.name")}
                            onChange={({ target: { checked } }) =>
                              onCheck({
                                module: option,
                                checked,
                              })
                            }
                            checked={
                              get(selectedModules, insurancePlan.id, []).find(
                                ({ insurancePlan }) =>
                                  insurancePlan?.id ===
                                  get(option, "insurancePlan.id", ""),
                              ) || false
                            }
                            disabled={disabled}
                          />
                          <div
                            className="upsells__checkbox--button"
                            onClick={() =>
                              onOpenDetails(get(option, "insurancePlan.id"))
                            }
                          >
                            <MdOpenInNew size={16} color={COLORS.C_PRIMARY} />
                          </div>
                        </div>
                        <div className="upsells__details--right">
                          <div className="insurance-plan__cost">
                            <span className="upsells__details--integer">
                              {`${integer} ${symbol} `}
                              <sup>{`${decimal}`}</sup>
                            </span>
                            <span className="upsells__details--period">{` /mois`}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              );
            })}
          </div>
        ))}
        <Button type="primary" size="full--width" onClick={onClose}>
          {get(translation, "UPSELLS.SAVE_CLOSE", "")}
        </Button>
      </div>
    </Drawer>
  );
};

export default ProductsDrawer;
